import ExpressExperienceLed from '../../assets/images/projects/experience_lead.gif'
import SquadLed from '../../assets/images/projects/squad_led.gif'
import StudioXLed from '../../assets/images/projects/studio_x.gif'
import TacticalExecutionLed from '../../assets/images/projects/tactical_execution.gif'

export const ProjectsData = [
  {
    title: 'Squad Led',
    description:
      'Requires an entirely new Persistent Platform or a new BBEI (CCI) that results in an E2E strategy and master assets toolkit.',
    img: SquadLed,
    link: '',
  },
  {
    title: 'Studio X Led',
    description:
      'A brief for a brand with existing brand positioning or platform that requires a new BBEI (CCI) that results in a new body of content. Always single OU in nature.',
    img: StudioXLed,
    link: '',
  },
  {
    title: 'Express Experience',
    description:
      'A simple project with an existing BBEI (CCI) that only requires new execution for additional touchpoints, or an unplanned project with creative development.',
    img: ExpressExperienceLed,
    link: '',
  },
  {
    title: 'Tactical Execution',
    description: 'Simple content execution of materials, no strategic or creative development required.',
    img: TacticalExecutionLed,
    link: '',
  },
]
